/*!
* @copyright
* Copyright(c) 2018 SICK AG
*/
const style = `@charset "UTF-8";
:host {
  display: block;
  width: 100%;
}

:host .gridx, :host .grid1, :host .grid2, :host .grid3 {
  display: grid;
  grid-gap: 0.25rem 1rem;
  grid-template-columns: repeat(auto-fit, minmax(80px, 1fr));
  justify-content: flex-start;
  justify-items: center;
  padding-left: 0.5rem;
  grid-auto-rows: -webkit-min-content;
  grid-auto-rows: min-content;
}
:host .gridx ::slotted(*)  , :host .grid1 ::slotted(*)  , :host .grid2 ::slotted(*)  , :host .grid3 ::slotted(*)   {
  align-self: center;
  justify-self: center;
}
:host .grid1 {
  grid-template-columns: 1fr;
}
:host .vbox {
  display: grid;
  grid-gap: 0.25rem 0;
  grid-template-columns: auto;
  grid-auto-rows: -webkit-min-content;
  grid-auto-rows: min-content;
  justify-items: left;
}
:host .compact {
  flex-wrap: wrap;
  display: flex;
  width: 100%;
  gap: 1rem;
}`;
export { style };
